<template>
  <div class="shopping-cart-promo-details m-t-35 m-b-24">
    <span class="shopping-cart-promo__active">
      Promo:
      <strong>{{ promoInfo.promoCode }}</strong>
      -
      <button class="iw-link-looking-button iw-hyperlink" @click="clearDiscount">Remove</button>
    </span>
    <span class="shopping-cart-promo__diff"> - {{ prependUsdSign(promoInfo.originalSubtotal - promoInfo.subtotal) }} </span>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { prependUsdSign } from "@/utils";

export default {
  name: "PromoDetails",
  computed: {
    ...mapGetters({
      promoInfo: "cart/getPromoInfo"
    })
  },
  methods: {
    ...mapActions({
      clearDiscount: "cart/clearDiscount"
    }),
    prependUsdSign
  }
};
</script>

<style scoped lang="scss">
.shopping-cart-promo-details {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
</style>
